import {FirebaseOptions} from "@firebase/app";

const gcsProject: string = "club15-test";

const firebaseConfig = {
    apiKey: "AIzaSyDTOkLPbmnG4fQq86pIlH984SWzVYrOuN4",
    authDomain: "club15-test.firebaseapp.com",
    databaseURL: "https://club15-test-default-rtdb.firebaseio.com",
    projectId: "club15-test",
    storageBucket: "club15-test.appspot.com",
    messagingSenderId: "740363599288",
    appId: "1:740363599288:web:d546a244b52b75cd3a234d"
};

export const environment = {
    getCloudBucket: function (name: string): string {
        return `${gcsProject}-${name}`
    },

    getFirebaseConfig: function (): FirebaseOptions {
        return firebaseConfig
    },

    getMapServiceUrl: function (): string {
        return "i.dashboard.15club.golf";
    },

    getAttributionBaseUrl: function (): string {
        return "";
    }
};
